import './header.scss';
import { drawer } from '../sidebar/sidebar';

const topAppBarElement = document.querySelector('[data-init="header"]');
// const mainContentElement = document.querySelector('[data-init="main"]');

let topAppBar;

if (topAppBarElement) {
	topAppBar = window.MDCTopAppBar.attachTo(topAppBarElement);

	// topAppBar.setScrollTarget(mainContentElement);

	topAppBar.listen('MDCTopAppBar:nav', () => {
		drawer.open = !drawer.open;
	});
}

export { topAppBar };
